$(document).ready(function () {



    $('.categoryDesc-firstPart').find('span').on('click', function () {
        $('.categoryDesc-secoundPart').fadeIn("slow");
        $(this).fadeOut("slow");
    });


    $('.categoryDesc-secoundPart').find('span').on('click', function () {
        $('.categoryDesc-secoundPart').fadeOut("slow");
        $('.categoryDesc-firstPart').find('span').fadeIn("slow");
    });


    // category page
    $('.ProductsResult').insertBefore('.SortName');


    // category page - add class if no top category banner
    var topCatImg = $('.TopCategory').find('img');
    if (topCatImg.length > 0) {
        $('.MainTopBanner').addClass('topBannerMargin');
    }

    // category page - change results number location
    $('.ProductsResult').insertBefore('.SortName');


    var shipPrices = $('#ShippingType').find('strong,b');
    var shipTd = $('#ShippingType').find('td');
    for (var i = 0; i < shipTd.length; i++) {
        $(shipPrices[i]).clone().appendTo(shipTd[i]);
    }

    //login-page input fields placeholders
    var loginInputs = $('.AccountControlCell').find('input');

    for (var i = 0; i < loginInputs.length; i++) {
        if ($(loginInputs[i]).val() != '') {
            $(loginInputs[i]).closest('tr').find('.AccountTextCell').addClass('input-focus');
        }
    }

    $(loginInputs).on('focus', function () {
        $(this).closest('tr').find('.AccountTextCell').addClass('input-focus');
    });

    $(loginInputs).focusout(function () {
        if ($(this).val() == '') {
            $(this).closest('tr').find('.AccountTextCell').removeClass('input-focus');
        }

    });


    // cart number of items 
    var cartItems = $('.NewShoppingHeader').find('td.NewShopProductName').length;
    if (cartItems > 0) {
        $('.ShopLinkDetails').append('<div class="cartnumofitems" style="display: block;">' + cartItems + '</div>');
    }

    //inscription 
    $('.inscriptionQuestion').click(function () {
        $(this).toggleClass('open');
    });

    if ($('.inscriptionQuestion').length > 0) {
        $('.ProductDotsRemarks').hide();
        //arrows
        $('.inscriptionQuestion').on('click', function () {
            $(this).siblings('.inscriptionAnswer').slideToggle();
            $(this).closest('.inscriptionBoxWrap').toggleClass('link-open');
        });
    }

    // shopping cart coupon code
    if (window.location.href.indexOf("promo_panel") != -1) {
        $("#promo_btn").attr('src', 'https://cdn.moncollierprenom.com/images/site/shopping_minus.png?v=8');
    }

    $("body").on("contextmenu", "img", function () {
        return false;
    });

    //scroll down review
    $(document).on('click', '.open-reviews', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    }); //scroll down review

});


$(document).ready(function () {

    // GA EVENT --- "Filter clear all" button click GA Event
    $(".search-filter-reset").on("click", function () {

        var prodLink = document.location.href;
        var list = prodLink.split("?")[1].split("=")[1].split("&")[0];
        var eventLabel = "clear_all_" + list;

        ga('send', {
            hitType: 'event',
            eventCategory: "category_page",
            eventAction: "click",
            eventLabel: eventLabel
        });

    });

    $(document).on('click', '.sendSurveyBtn', function () {

        // set values
        q1_val = $(".surveyContent .question_1 input[name=question_1]:checked").val();
        q2_val = $(".surveyContent .question_2 input[name=question_2]:checked").val();
        q2_otherIsChecked = $(".question_2 > ul > li").last().find("input").is(":checked");
        q3_val = $(".surveyContent .question_3 textarea").val();

        // set labels
        q1_eventLabel = "survey_q1_" + q1_val;

        if (q2_val == "other") {
            q2_eventLabel =
                "survey_q3_" + $(".question_2 .AnswerOther").val().trim().split(" ").join("_");
        } else {
            q2_eventLabel = "survey_q2_" + q2_val;
        }

        q3_eventLabel = "survey_q4_" + q3_val.trim().split(" ").join("_");

        // validate values
        if (q1_val == undefined || q2_val == undefined) {
            return;
        }
        if (q2_otherIsChecked && $(".question_2 textarea").val().length == 0) {
            return;
        }
        if (q3_val.length == 0) {
            return;
        }

        $(".thank_you_survey_feedback").show();
        $(".thanksOrderSurvey").hide();

        // send GA events
        // survey question 1
        ga("send", {
            hitType: "event",
            eventCategory: "thank_you_page",
            eventAction: "click",
            eventLabel: q1_eventLabel
        });

        // survey question 2
        ga("send", {
            hitType: "event",
            eventCategory: "thank_you_page",
            eventAction: "click",
            eventLabel: q2_eventLabel
        });

        // survey question 3
        ga("send", {
            hitType: "event",
            eventCategory: "thank_you_page",
            eventAction: "click",
            eventLabel: q3_eventLabel
        });

    });
});